export async function execute(args, context) {
  const { styleIndex } = context;
  const { selector } = args;

  if (!styleIndex || Object.keys(styleIndex).length === 0) {
    return {
      success: false,
      error: 'Style index not available. Try reloading the page.'
    };
  }

  // Direct match
  const directMatch = styleIndex[selector];
  if (directMatch && directMatch.length > 0) {
    return {
      success: true,
      selector,
      definitions: directMatch.map(d => ({
        file: d.file,
        line: d.line,
        source: d.source,
        rule: d.rule
      }))
    };
  }

  // Partial match - find selectors containing our search
  const partialMatches = Object.keys(styleIndex)
    .filter(s => s.includes(selector) || selector.includes(s))
    .slice(0, 5);

  if (partialMatches.length > 0) {
    return {
      success: false,
      error: `No exact match for "${selector}"`,
      suggestions: partialMatches,
      note: 'Try one of the suggested selectors'
    };
  }

  return {
    success: false,
    error: `No styles found for selector: ${selector}`,
    note: 'Element may have inline styles or no styles defined'
  };
}
